import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

@Component({
  selector: 'bmcore-loader',
  templateUrl: './bmcore-loader.component.html',
  styleUrls: ['./bmcore-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreLoaderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
